import { Box, Modal, TextField } from "@mui/material";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import useAPI from "../../../../api/hooks/useAPI";
import useColors from "../../../../api/hooks/useColors";
import ContainedButton from "../../../../components/buttons/ContainedButton";
import TextButton from "../../../../components/buttons/TextButton";
import { Toast } from "../../../../components/Toast";
import { resetQueriesAfterAutoRemediation } from "../../../posture/controls/components/ControlRemediationDrawer/remediation/autoRemediation/utils";

export default function ResetRemediationButton() {
  const colors = useColors();
  const queryClient = useQueryClient();
  const { resetRemediation } = useAPI();
  const [showModal, setShowModal] = useState(false);
  const [controlId, setControlId] = useState(null);

  const resetMutation = useMutation({
    mutationFn: () => resetRemediation(controlId),
    onSuccess: () => {
      Toast.success(`Remediation ${controlId} was reset successfully`);
      setShowModal(false);
      resetQueriesAfterAutoRemediation(queryClient, controlId);
    },
    onError: (error) => {
      if (error?.response?.data?.detail)
        Toast.error(error.response.data.detail);
      else Toast.error(error.message);
    },
    onSettled: () => {
      setControlId(null);
      setShowModal(false);
    },
  });

  return (
    <>
      <ContainedButton
        onClick={() => setShowModal(true)}
        color="primary"
        size="medium"
      >
        Reset Remediation
      </ContainedButton>
      <Modal open={showModal} onClose={() => setShowModal(false)}>
        <Box
          position="absolute"
          borderRadius="10px"
          top="50%"
          left="50%"
          display="flex"
          flexDirection="column"
          gap="16px"
          padding="32px"
          sx={{
            transform: "translate(-50%, -50%)",
            backgroundColor: colors.modal_bg,
            outline: "none",
            border: `1px solid ${colors.success_48percent}`,
          }}
        >
          <TextField
            label="Control ID"
            type="number"
            value={controlId}
            onChange={(e) => setControlId(e.target.value)}
          />
          <Box display="flex" justifyContent="center" gap="16px">
            <TextButton onClick={() => setShowModal(false)}>Cancel</TextButton>
            <ContainedButton
              onClick={() => resetMutation.mutate()}
              color="primary"
              size="medium"
              disabled={!controlId || controlId <= 0}
              loading={resetMutation.isPending}
            >
              Reset
            </ContainedButton>
          </Box>
        </Box>
      </Modal>
    </>
  );
}
